import type { Record } from 'pkg/api/models/record';

export enum TagType {
	Unknown = 'unknown',
	Exercise = 'exercise',
	TrainingSession = 'trainingSession',
	Video = 'video',
}

export interface Tag extends Record {
	name: string;
	groupId?: number;
	type: TagType;
}
